const TradingRouter = [
  // {
  //   path: 'Home',
  //   name: 'Home',
  //   title: '首页',
  //   icon: 'icon-leftnav_pricing',
  //   meta: {}
  // },
  {
    path: 'TradingCenterIndex',
    name: 'TradingCenterIndex',
    title: '我是供应商',
    meta: {
      disabled: true
    }
  },
  {
    path: 'InventoryPricing',
    name: 'InventoryPricing',
    title: '库存定价',
    icon: 'icon-leftnav_pricing',
    meta: {
      belongTo: 'InventoryPricing',
      hide: true
    }
  },
  {
    path: 'ReceivedInquiry',
    name: 'ReceivedInquiry',
    title: '收到的询价',
    icon: 'icon-leftnav_received',
    meta: {}
  },
  {
    path: 'SalesOrder',
    name: 'SalesOrder',
    title: '销售订单',
    icon: 'icon-leftnav_my-orders',
    meta: {}
  },
  {
    path: 'Statement',
    name: 'Statement',
    title: '电子对账单',
    icon: 'icon-leftnav_my-orders',
    meta: {}
  },
  {
    path: 'SalesChannels',
    name: 'SalesChannels',
    title: '销售管道',
    icon: 'icon-leftnav_channel',
    meta: {
      hide: true
    }
  },
  {
    path: 'ChannelAnalysis',
    name: 'ChannelAnalysis',
    title: '管道分析',
    icon: 'icon-leftnav_statistics',
    meta: {
      belongTo: 'InventoryPricing',
      hide: true
    }
  },

  {
    path: 'PricingStrategy',
    name: 'PricingStrategy',
    title: '定价设置',
    icon: 'icon-leftnav_strategy',
    meta: {
      hide: true
    }
  },
  {
    path: 'TradingCenterOutgoing',
    name: 'TradingCenterOutgoing',
    title: '我是采购商',
    meta: {
      disabled: true
    }
  },
  {
    path: 'MyBom',
    name: 'MyBom',
    title: '我的BOM',
    icon: 'icon-leftnav_my-orders',
    meta: {
      // hide: true
    }
  },
  {
    path: 'OutgoingInquiry',
    name: 'OutgoingInquiry',
    title: '发出的询价',
    icon: 'icon-leftnav_send',
    meta: {}
  },

  {
    path: 'PurchaseOrder',
    name: 'PurchaseOrder',
    title: '采购订单',
    icon: 'icon-leftnav_my-orders',
    meta: {}
  },

  {
    path: 'PurchaseOrderList',
    name: 'PurchaseOrderList',
    title: '采购订单',
    icon: 'icon-leftnav_my-orders',
    meta: {}
  },
  {
    path: 'PurchaseOrderListDetails',
    name: 'PurchaseOrderListDetails',
    title: '订单详情',
    icon: 'icon-leftnav_my-orders',
    meta: {}
  },

  {
    path: 'BaseInformation',
    name: 'BaseInformation',
    title: '基本信息',
    meta: {
      disabled: true
    }
  },
  {
    path: 'Information',
    name: 'Information',
    title: '基本信息',
    icon: 'icon-leftnav_send',
    meta: {}
  }
];

export default TradingRouter;
